import { render, staticRenderFns } from "./OddsModalTabs.vue?vue&type=template&id=208cf09f&scoped=true&"
import script from "./OddsModalTabs.vue?vue&type=script&lang=js&"
export * from "./OddsModalTabs.vue?vue&type=script&lang=js&"
import style0 from "./OddsModalTabs.vue?vue&type=style&index=0&id=208cf09f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208cf09f",
  null
  
)

export default component.exports